import { render, staticRenderFns } from "./examineCenter.vue?vue&type=template&id=aaa5022c&scoped=true&"
import script from "./examineCenter.vue?vue&type=script&lang=js&"
export * from "./examineCenter.vue?vue&type=script&lang=js&"
import style0 from "./examineCenter.vue?vue&type=style&index=0&id=aaa5022c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa5022c",
  null
  
)

export default component.exports